import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Box,
} from '@mui/material';

const PermissionPopup = ({open, onClose, onAllow, permissionDenied}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiPaper-root': {
          borderRadius: 0,
        },
      }}
    >
      <Box
        sx={{
          padding: 3,
          background: '#1a1a1a',
        }}
      >
        <Box
          sx={{
            position: 'absolute', // Absolute positioning for the border
            bottom: '60%',
            left: '0%',
            width: '2px', // Border thickness
            height: '30%', // Extend up to the center
            backgroundColor: '#fff', // Border color
            boxShadow: '0 0 10px rgba(255, 255, 255, 0.7)', // White drop shadow
          }}
        />
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          {/* Image */}
          <Box
            sx={{
              width: 100,
              height: 100,
              background: `url("${process.env.REACT_APP_CDN}/cardHead.png") no-repeat center/cover`,
              marginBottom: 2,
            }}
          />
          {permissionDenied ? (
            <>
              <Typography
                variant="h6"
                color="white"
                fontFamily="Klapt"
                sx={{
                  fontWeight: '700',
                }}
                gutterBottom
              >
                Permission Denied
              </Typography>
              <Typography
                variant="body2"
                color="white"
                style={{
                  fontFamily: 'DisketMonoRegular',
                  fontWeight: '400',
                  fontSize: '12px',
                  marginTop: '16px',
                  whiteSpace: 'pre-line',
                  textAlign: 'left',
                }}
              >
                {'To enable the motion sensor:'}
                {'\n'}1. Go to{' '}
                <span style={{fontSize: '13px', fontFamily: 'disketMono'}}>
                  Settings
                </span>{' '}
                on your device.
                {'\n'}2. Navigate to{' '}
                <span style={{fontSize: '13px', fontFamily: 'disketMono'}}>
                  Privacy &gt; Motion & Fitness
                </span>
                .{'\n'}3. Find your app and toggle{' '}
                <span style={{fontSize: '13px', fontFamily: 'disketMono'}}>
                  Allow Motion Access
                </span>
                .{'\n\n'}
                For Safari users:
                {'\n'}1. Open the{' '}
                <span style={{fontSize: '13px', fontFamily: 'disketMono'}}>
                  Settings
                </span>{' '}
                app.
                {'\n'}2. Scroll to{' '}
                <span style={{fontSize: '13px', fontFamily: 'disketMono'}}>
                  Safari
                </span>{' '}
                and tap it.
                {'\n'}3. Enable{' '}
                <span style={{fontSize: '13px', fontFamily: 'disketMono'}}>
                  Motion & Orientation Access
                </span>{' '}
                under{' '}
                <span style={{fontSize: '13px', fontFamily: 'disketMono'}}>
                  Privacy & Security
                </span>
                .
              </Typography>
            </>
          ) : (
            <>
              <Typography
                variant="h6"
                color="white"
                fontFamily="Klapt"
                sx={{
                  fontWeight: '700',
                }}
                gutterBottom
              >
                ACTIVATE MOTION SENSOR
              </Typography>

              <Typography
                variant="body2"
                color="white"
                style={{
                  fontFamily: 'DisketMonoRegular',
                  fontWeight: '400',
                  fontSize: '12px',
                  whiteSpace: 'pre-line', // Preserves line breaks
                }}
                gutterBottom
              >
                ELEVATE YOUR AIRSPACE{'\n'}
                EXPERIENCE BY TURNING ON{'\n'}
                MOTION SENSOR
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  gap: 2,
                }}
              >
                <Button
                  sx={{
                    borderLeft: '1px solid #FFFFFF',
                    borderRight: '1px solid #FFFFFF',
                    borderBottom: '1px solid #FFFFFF',
                    backgroundColor: '#000000',
                    color: 'white',
                    position: 'relative',
                    marginTop: '45px',
                    padding: '10px',
                    width: '100%',
                    borderRadius: 0,
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '25%',
                      borderTop: '1px solid #FFFFFF',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    fontFamily: 'DisketMono',
                  }}
                  onClick={onAllow}
                >
                  ALLOW
                </Button>
                <Button
                  variant="text"
                  onClick={onClose}
                  sx={{
                    textDecoration: 'underline',
                    fontFamily: 'DisketMono',
                    color: '#DEE0E1',
                    fontSize: '14px',
                  }}
                >
                  SKIP FOR NOW
                </Button>
              </Box>
            </>
          )}
          {/* Heading */}
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default PermissionPopup;
